import { getField } from 'vuex-map-fields'

export default {
    getField
}
